var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "volume_low_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#volume_low_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.313H8a.968.968 0 01-.713-.288.968.968 0 01-.287-.712v-4c0-.284.096-.521.287-.713A.967.967 0 018 13.313h3l3.3-3.3c.317-.317.68-.388 1.087-.213.409.175.613.487.613.938v11.15c0 .45-.204.762-.613.937-.408.175-.77.104-1.087-.212l-3.3-3.3zm9.5-3c0 .7-.158 1.362-.475 1.987a4.46 4.46 0 01-1.25 1.537.493.493 0 01-.512.013.46.46 0 01-.263-.438v-6.25c0-.2.087-.345.262-.437a.493.493 0 01.513.013c.517.416.933.941 1.25 1.575.317.633.475 1.3.475 2z",
    fill: "#fff"
  }))));
}
export default SvgVolumeLow;